import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledToggle = styled(ToggleButtonGroup)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)',
  borderRadius: 25,
  padding: 4,
  '& .MuiToggleButton-root': {
    border: 'none',
    borderRadius: 25,
    padding: '8px 24px',
    textTransform: 'none',
    fontWeight: 500,
    '&.Mui-selected': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
    },
    '&:not(.Mui-selected)': {
      color: theme.palette.text.secondary,
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
}));

type BillingPeriod = 'monthly' | 'annual';

interface BillingToggleProps {
  value: BillingPeriod;
  onChange: (event: React.MouseEvent<HTMLElement>, newPeriod: BillingPeriod | null) => void;
}

export function BillingToggle({ value, onChange }: BillingToggleProps) {
  return (
    <StyledToggle
      value={value}
      exclusive
      onChange={onChange}
      aria-label="billing period"
    >
      <ToggleButton value="monthly" aria-label="monthly">
        Monthly
      </ToggleButton>
      <ToggleButton value="annual" aria-label="annual">
        Yearly
      </ToggleButton>
    </StyledToggle>
  );
}

